<template>
  <div class="employee-list-container">
    <v-card
      class="employee-list"
      height="100%"
    >
      <v-card-title class="employee-list__card-title">
        Employee

        <v-menu offset-y close-on-click close-on-content-click>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              outlined
              v-bind="attrs"
              v-on="on"
              color="primary"
              class="ml-4"
            >
              Labels
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense class="pa-2" style="max-height: 300px; overflow-y: auto;">
            <v-list-item>
              <v-checkbox
                dense
                hide-details
                label="All Labels"
                v-model="selectAllLabels"
                @change="toggleAllLabels"
              ></v-checkbox>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              v-for="label in sortedLabels"
              :key="label.Label_ID"
            >
              <v-checkbox
                dense
                hide-details
                :label="label.Label_Name"
                v-model="selectedLabels"
                :value="label.Label_ID"
                @change="updateLabelSelection"
              ></v-checkbox>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-spacer></v-spacer>
        <v-text-field
          dense
          hide-details
          placeholder="Search"
          v-model="search"
          clearable
          clear-icon="mdi-close-circle-outline"
          @click:clear="onClearSearchClick()"
        ></v-text-field>
        <v-btn
          icon
          color="primary"
          @click="showSettingsList = true"
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-3">
        <v-checkbox
          dense
          hide-details
          class="pa-0 ma-0 mb-2"
          label="Select All"
          v-model="selectAll"
          :indeterminate="indeterminate"
          @change="onSelectAllChanged"
        ></v-checkbox>
        <div :key="'select_all_' + toggleEmployee + search + updatedList + labelFilterKey">
          <EmployeeItem
            v-for="(employee, key) in employeeFilteredList"
            :key="key"
            :employee="employee"
            :labels="labels"
            :active-filters="selectedLabels"
            :value="value"
            @input="onEmployeeItemInput"
          />
        </div>
      </v-card-text>
    </v-card>
    <EmployeeListSettingsDialog
      v-model="showSettingsList"
      :selectedEmployees="value.selectedEmployee"
      @updateEmployeeList="getEmployeeList"
    />
    <!-- Add new Project to current List dialog -->
    <v-dialog
      v-model="showRedirectedDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Selected employee is not on the list
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4">
          Selected employee will added to your list. Do you want to add it?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn small color="red darken-2 white--text" @click="assignSelectedEmployee">Proceed without adding</v-btn>
          <v-btn small color="success" @click="addRedirectedEmployeeToList">Yes, add employee</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /Add new Project to current List dialog -->
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'EmployeeList',
  components: {
    EmployeeListSettingsDialog: () => import('@/components/global/EmployeeListSettingsDialog.vue'),
    EmployeeItem: () => import('@/components/manager_reports/EmployeeItem.vue')
  },
  props: {
    value: {
      required: false,
      type: Object,
      default: () => {
        return {
          selectedProjects: [],
          selectedTasks: [],
          selectedFolders: [],
          selectedEmployee: []
        }
      }
    },
    redirectedEmployee: {
      required: false
    },
    restoredState: {
      required: false,
      type: Object,
      default: null
    }
  },
  data () {
    return {
      search: '',
      employeeList: [],
      showSettingsList: false,
      toggleEmployee: false,
      showNotIncludedEmployeeDialog: false,
      updatedList: false,
      selectAll: false,
      labels: [],
      selectedLabels: [],
      selectAllLabels: false,
      labelFilterKey: 0,
      skippingPersist: false
    }
  },
  computed: {
    indeterminate () {
      return this.value.selectedEmployee && this.value.selectedEmployee.length > 0 && this.value.selectedEmployee.length !== this.employeeFilteredList.length
    },
    user () {
      return this.$store.getters.getUser
    },
    sortedLabels () {
      return [...this.labels].sort((a, b) => a.Label_Name.localeCompare(b.Label_Name))
    },
    employeeFilteredList () {
      let employees = this.employeeList

      if (this.search) {
        const r = new RegExp(this.search, 'gi')
        employees = employees.filter(empl => {
          r.lastIndex = 0
          return r.test(empl.Full_Name)
        })
      }

      if (this.selectAllLabels) {
        employees = employees.filter(employee =>
          Array.isArray(employee.Label_IDs) && employee.Label_IDs.length > 0
        )
      } else if (this.selectedLabels.length > 0) {
        employees = employees.filter(employee => {
          if (!employee.Label_IDs || !Array.isArray(employee.Label_IDs)) return false
          return employee.Label_IDs.some(labelId => this.selectedLabels.includes(labelId))
        })
      }

      return employees
    },
    showRedirectedDialog: {
      get () {
        return this.showNotIncludedEmployeeDialog
      },
      set (value) {
        this.showNotIncludedEmployeeDialog = value
      }
    }
  },
  created () {
    if (this.restoredState) {
      this.skippingPersist = true
      if (typeof this.restoredState.search === 'string') {
        this.search = this.restoredState.search
      }
      if (Array.isArray(this.restoredState.selectedLabels)) {
        this.selectedLabels = [...this.restoredState.selectedLabels]
      }
      if (typeof this.restoredState.selectAllLabels === 'boolean') {
        this.selectAllLabels = this.restoredState.selectAllLabels
      }
    }
  },
  mounted () {
    const initialSelected = this.restoredState && Array.isArray(this.restoredState.selectedEmployee)
      ? this.restoredState.selectedEmployee
      : (this.value.selectedEmployee ? this.value.selectedEmployee : [])
    this.$emit('input', {
      selectedEmployee: initialSelected
    })
    this.getEmployeeList()
    this.getLabels()
    this.$nextTick(() => {
      this.skippingPersist = false
      this.emitEmployeeUiPersist()
    })
  },
  methods: {
    emitEmployeeUiPersist () {
      if (this.skippingPersist || this.redirectedEmployee) return
      this.$emit('persistEmployeeUi', {
        search: this.search || '',
        selectedLabels: this.selectedLabels || [],
        selectAllLabels: !!this.selectAllLabels
      })
    },
    onClearSearchClick () {
      setTimeout(() => {
        this.search = ''
        this.emitEmployeeUiPersist()
      })
    },
    onSelectAllChanged (e) {
      this.toggleEmployee = e
      if (e) {
        const allEmployeeIds = this.employeeFilteredList.map(empl => empl.Employee_ID)
        this.$emit('input', {
          ...this.value,
          selectedEmployee: allEmployeeIds
        })

        this.employeeList.forEach(employee => {
          if (this.employeeFilteredList.some(empl => empl.Employee_ID === employee.Employee_ID)) {
            employee.Is_Selected = true
          }
        })
      } else {
        this.$emit('input', {
          ...this.value,
          selectedEmployee: []
        })

        this.employeeList.forEach(employee => {
          if (this.employeeFilteredList.some(empl => empl.Employee_ID === employee.Employee_ID)) {
            employee.Is_Selected = false
          }
        })
      }
    },
    async getEmployeeList (newEmployee) {
      try {
        const res = await this.axios.get('/api/selected-employee-list-cmp', {
          headers: { Authorization: 'Bearer ' + this.user.token }
        })

        this.employeeList = res.data.map(e => ({
          ...e,
          Is_Selected: false,
          Label_IDs: []
        }))

        await this.loadEmployeeLabels()

        if (this.redirectedEmployee && !newEmployee) {
          const emp = this.employeeList.find(item => item.Employee_ID === this.redirectedEmployee)
          if (!emp) {
            this.showRedirectedDialog = true
          } else {
            this.$emit('input', { selectedEmployee: [this.redirectedEmployee] })
            this.getRedirectedReports()
          }
          return
        }
        if (newEmployee) {
          this.$emit('input', { selectedEmployee: [newEmployee.Employee_ID] })
          this.updatedList = !this.updatedList
          this.getRedirectedReports()
        } else {
          // Restore Is_Selected checkboxes from parent/restored selection
          const selected = (this.value && this.value.selectedEmployee) || []
          const validSelected = selected.filter(id =>
            this.employeeList.some(e => String(e.Employee_ID) === String(id))
          ).map(id => {
            const match = this.employeeList.find(e => String(e.Employee_ID) === String(id))
            return match ? match.Employee_ID : id
          })
          this.employeeList.forEach(employee => {
            employee.Is_Selected = validSelected.some(id => String(id) === String(employee.Employee_ID))
          })
          if (validSelected.length !== selected.length) {
            this.$emit('input', { selectedEmployee: validSelected })
          }
          this.updateSelectAllState()
          this.updatedList = !this.updatedList
        }
      } catch (error) {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }
    },
    async loadEmployeeLabels () {
      try {
        const res = await this.axios.get('/api/employee-list-cmp', {
          headers: { Authorization: 'Bearer ' + this.user.token }
        })

        res.data.forEach(employee => {
          if (employee.Label_IDs) {
            const labelIds = employee.Label_IDs
              ? employee.Label_IDs.split(',').map(id => Number(id.trim())).filter(id => !isNaN(id))
              : []

            const empIndex = this.employeeList.findIndex(e => e.Employee_ID === employee.Employee_ID)
            if (empIndex !== -1) {
              this.$set(this.employeeList[empIndex], 'Label_IDs', labelIds)
            }
          }
        })
      } catch (error) {
        console.error('Error loading employee labels:', error)
      }
    },
    async getLabels () {
      try {
        const res = await this.axios.get('/api/project_employee_labels', {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        })
        this.labels = res.data
        if (this.selectedLabels.length) {
          const validIds = new Set(this.labels.map(l => l.Label_ID))
          const filtered = this.selectedLabels.filter(id => validIds.has(id))
          if (filtered.length !== this.selectedLabels.length) {
            this.selectedLabels = filtered
          }
        }
      } catch (error) {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }
    },
    toggleAllLabels () {
      if (this.selectAllLabels) {
        this.selectedLabels = []
      }
      this.labelFilterKey++
    },
    updateLabelSelection () {
      if (this.selectedLabels.length > 0) {
        this.selectAllLabels = false
      }
      this.labelFilterKey++
    },
    updateSelectAllState () {
      if (this.employeeFilteredList.length === 0) {
        this.selectAll = false
        return
      }

      const allSelected = this.employeeFilteredList.every(empl =>
        this.value.selectedEmployee.includes(empl.Employee_ID)
      )

      this.selectAll = allSelected
    },
    addRedirectedEmployeeToList () {
      this.axios.post('/api/projects-list-cmp/redirectedemployee', { Employee_ID: this.redirectedEmployee }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.getEmployeeList(res.data[0])
        this.showRedirectedDialog = false
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    assignSelectedEmployee () {
      this.$emit('input', {
        ...this.value,
        selectedEmployee: [this.redirectedEmployee]
      })
      this.getRedirectedReports()
    },
    getRedirectedReports () {
      setTimeout(() => {
        this.$emit('getReportsOnRedirect')
      })
    },
    onEmployeeItemInput (newValue) {
      this.$emit('input', newValue)
    }
  },
  watch: {
    'value.selectedEmployee': {
      handler (newSelected) {
        if (this.employeeList) {
          this.employeeList.forEach(employee => {
            employee.Is_Selected = newSelected.includes(employee.Employee_ID)
          })
        }

        this.updateSelectAllState()
      },
      deep: true
    },
    search () {
      this.$nextTick(() => {
        this.updateSelectAllState()
      })
      this.emitEmployeeUiPersist()
    },
    selectedLabels () {
      this.$nextTick(() => {
        this.updateSelectAllState()
      })
      this.emitEmployeeUiPersist()
    },
    selectAllLabels () {
      this.$nextTick(() => {
        this.updateSelectAllState()
      })
      this.emitEmployeeUiPersist()
    }
  }
}
</script>
<style lang="scss" scoped>
  .employee-list-container {
    height: calc(45vh - 15px);
    margin: 30px 0 0;
  }
  .employee-list {
    overflow: auto;
    &__card-title {
      position: sticky;
      top: 0;
      background-color: inherit;
      z-index: 1;
    }
    &__card-subtitle {
      position: sticky;
      top: 68px;
      z-index: 1;
    }
  }
</style>
